import React from 'react';
import RefreshIcon from '@material-ui/icons/Refresh';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import * as links from '../../../../../../constants/links';
import {
  Link,
  pushLocation,
} from '../../../../../../router';
import {
  apiAdminPayoutNiumRemitterList,
} from '../../../../../../api/admin/payout/nium/remitter';
import LayoutA from '../../../../../dumb/Layout/A';
import CaptionA from '../../../../../dumb/Caption/A';
import HeaderA from '../../../../../dumb/Header/A';
import ButtonUp from '../../../../../dumb/Button/Up';
import Tooltip from '../../../../../dumb/Tooltip/A';
import RowA from '../../../../../dumb/Row/A';
import ColA from '../../../../../dumb/Col/A2';
import RowB from '../../../../../dumb/Row/B';
import ColB from '../../../../../dumb/Col/B2';
import Ripple from '../../../../../dumb/Ripple';
import ButtonD from '../../../../../dumb/Button/D';
import InfoIcon from '../../../../../icons/Info';
import WrapperWithLoading from '../../../../../dumb/WrapperWithLoading';

module.exports = require('../../../../../../utils/virtualOutputComponentProvider')({
  rowHeight: 70,
  request: apiAdminPayoutNiumRemitterList,
  wrapper(render, setState, self) {
    function Item({
      data,
    }) {
      const id = data.nium_account_id || '';
      const fiatCode = data.fiat_code || '';
      const name = data.name || '';

      return (
        <div className="dB w olN tdN cF dn bgF1:h">
          <RowA className="f12">
            <ColA className="wmin100 fx1">
              <Tooltip>{id}</Tooltip>
            </ColA>
            <ColA className="wmin100 fx1">
              <Tooltip>{name}</Tooltip>
            </ColA>
            <ColA className="wmin100 fx1">
              <Tooltip>{fiatCode}</Tooltip>
            </ColA>
            <ColA className="w50">
              <Tooltip title="Details" disabledCopy>
                <Ripple
                  className="w40 h40 p7 r7 (bgc0.25):h"
                  onClick={() => {
                    pushLocation({
                      path: `${links.LINK_ADMIN_PAYOUT_NIUM_REMITTERS}/${id}/${fiatCode}`,
                    });
                  }}
                >
                  <InfoIcon/>
                </Ripple>
              </Tooltip>
            </ColA>
          </RowA>
        </div>
      );
    }

    return (state) => {
      return (
        <LayoutA>
          <HeaderA>
            <CaptionA>Payout | Nium remitters</CaptionA>
            <div className="layoutRow fhaS fvaC">
              <ButtonD
                className="wmin100"
                component={Link}
                href={links.LINK_ADMIN_PAYOUT_NIUM_REMITTER_ADD}
              >
                <AddCircleOutlineIcon/>
                <div className="pl15">Add</div>
              </ButtonD>
              <WrapperWithLoading
                loading={state.loading}
              >
                <ButtonD
                  className="wmin100"
                  onClick={self.update}
                >
                  <RefreshIcon/>
                  <div className="pl15">Refresh</div>
                </ButtonD>
              </WrapperWithLoading>
            </div>
          </HeaderA>
          <div className="abs st70 sh-45 sb10 ov">
            <div className="ovxA abs s ph45">
              <div className="wmin350 rlv h">
                <div>
                  <RowB className="f12">
                    <ColB className="wmin100 fx1">ID</ColB>
                    <ColB className="wmin100 fx1">Name</ColB>
                    <ColB className="wmin100 fx1">Currency</ColB>
                    <ColB className="w50"/>
                  </RowB>
                </div>
                <div className="abs st70 sh-45 sb10 ovH">
                  {render(Item)}
                </div>
              </div>
            </div>
            <ButtonUp
              show={state.showUp}
              onClick={self.handleToUp}
            />
          </div>
        </LayoutA>
      );
    };
  },
});
